$(document).ready(function() {
  var items = document.getElementsByClassName('toggle-heading');
  for(var i=0; i < items.length; i++){
    items[i].onclick = accordionOnClick;
  }
});

function accordionOnClick(){
  var header = document.getElementById(this.id);
  var content = document.getElementById(this.id+'-content');

  $(header).toggleClass('active');
  $(content).toggleClass('hidden');
}